import { useMatomo } from '@jonkoops/matomo-tracker-react'
import { TrackPageViewParams } from '@jonkoops/matomo-tracker-react/lib/types'
import { TrackEventParams } from '@jonkoops/matomo-tracker/lib/types'
import { useRef } from 'react'

type TimedEvent = {
    category: string
    action: string
    name?: string
    value?: number
}

export const useAnalytics = () => {
    const {
        trackEvent: trackMatomoEvent,
        trackPageView: trackMatomoPageView,
        pushInstruction
    } = useMatomo()
    const startTime = useRef(Date.now())

    const trackEvent = (data: TrackEventParams) => {
        trackMatomoEvent(data)
    }

    const trackTimedEvent = ({ category, action, name, value }: TimedEvent) => {
        const endTime = Date.now()
        const duration = endTime - startTime.current

        trackEvent({ category, action, name, value: value || duration })
    }

    const trackPageView = (params: TrackPageViewParams) => {
        trackMatomoPageView(params)
    }

    // Matomo does not persist the user id or visit dimensions between page
    // loads, so push them on every call (app start, login) rather than once
    // per expiry window; otherwise ~half of visits report no user and no role.
    const updateUserInfo = (username?: string, role?: string) => {
        if (!username || !role) {
            return
        }
        pushInstruction('setCustomDimension', 2, role)
        pushInstruction('setUserId', username)
    }

    const resetTimedEvent = () => {
        startTime.current = Date.now()
    }

    return {
        trackEvent,
        updateUserInfo,
        trackTimedEvent,
        trackPageView,
        resetTimedEvent
    }
}
